<template>
  <div class="law_detail main-page">
    <Menu :title="$route.query.title||'法律法规'" :homee="true">
      <template slot="right-link">
        <div class="servicePoint">
        </div>
      </template>
    </Menu>
    <div class="law-wrap container-flex">
      <div class="law-left" v-if="hideLeftNav">
        <div class="search-box">
          <div class="input-box">
            <input type="text" v-model="keywords" placeholder="输入关键字在本法条内搜索">

            <button @click="searchKeywords()">
              <img src="/img/ui/law/search_49.png">
            </button>
          </div>
          <div class="no-keywords" v-if="searchResult">没有搜索到数据，请重新搜索</div>
        </div>

        <div class="menu-box noscroll">
          <div class="hts">
            <span>目录</span>
          </div>
          <template v-if="navTree.length">
            <TreeDirectory :treeData="navTree" @jump="jumpToAnchor"></TreeDirectory>
          </template>
          <div class="menulist" v-else>
            <span class="empty-info">全部内容</span>
          </div>
        </div>

      </div>
      <div class="law-right">
        <div class="main-content noscroll" id="main-content">
          <h1>{{ article.name }}</h1>
          <div class="intro">
            <span>效力等级：{{ article.fLevel }}</span>
            <span>效力状态：{{ article.status }}</span>
            <span>所属专业：{{ article.professionalName }}</span>
            <span>发布日期：{{ $moment(article.issueDate).format('YYYY-MM-DD HH:mm') }}</span>
            <span>施行日期：{{ $moment(article.enforcementDate).format('YYYY-MM-DD HH:mm') }}</span>
            <span>发布单位：{{ article.org }}</span>
            <span v-if="article.status === '失效'">失效日期： {{ $moment(article.expiryDate).format('YYYY-MM-DD HH:mm') }}</span>
          </div>
        </div>
        <div v-directory="outline" class="out-line">
          <div class="details-content">
            <treeArticle :treeData="content">
              <template v-slot:default="{ data }">
                <div class="pro-node" :level="data.level">
                  <h3 :id="data.id" :anchor="'lawitem-' + data.id" v-html="showContent(data.title)">
                  </h3>
                  <p v-html="showContent(data.content)"></p>
                </div>
              </template>
            </treeArticle>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import Menu from '@/components/Menu'
import { listToTree } from '@/plugins'

import * as lawApi from '../../datas/js/law'
import treeArticle from '@/components/tree-article'
import TreeDirectory from '@/components/tree-directory'

export default {
  components: {
    Menu,
    treeArticle,
    TreeDirectory
  },
  data () {
    return {
      lawId: '',
      article: {},
      content: [],
      keywords: '',
      searchResult: false,
      navTree: [],
      outline: {
        callback: this.refreshNavTree,
        selectors: ['[level="1"]', '[level="2"]', '[level="3"]', '[level="4"]']
      },
      jumpIndex: 0,
    }
  },
  computed: {
    hideLeftNav () {
      return !this.$route.query.hide_nav
    }
  },
  mounted () {
    let lawId = this.$route.params.id
    this.lawId = lawId || null
    this.lawId && this.getLawDetails(() => {
      if (lawId) {
        this.$nextTick(() => {
          const element = this.$el.querySelector(`[anchor=lawitem-${lawId}]`)
          element && element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
        })
      }
    })
  },
  methods: {
    async getLawDetails (callback) {
      this.$loading.show()
      let id = this.$route.params.id
      try {
        let results = await lawApi.getLawDetail(id)
        if (results.response.success) {
          this.article = results.data
          let content = results.data.articles
          this.content = listToTree(content.filter(item => {
            let length = (item.treePath && item.treePath.split('.').length) || 1
            item.level = length
            return item
          }), undefined, undefined, false)
          this.$loading.hide()
          callback && callback(results.data)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.$loading.hide()
      }
    },
    showContent (content) {
      if (!this.keywords) return content
      let reg = new RegExp(`(${this.keywords})`, 'g')
      if (reg.test(content)) {
        return content.replace(reg, `<font class="include-keyword" style="color: #409EFF">${this.keywords}</font>`)
      } else {
        return content
      }
    },
    refreshNavTree (treeData) {
      this.navTree = treeData
    },
    jumpToAnchor (id) {
      this.$nextTick(() => {
        let element = document.getElementById(id)
        element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
      })
    },
    searchKeywords () {
      this.$nextTick(() => {
        let nodeList = this.$el.querySelectorAll('font.include-keyword')
        if (!nodeList || !nodeList.length) {
          this.searchResult = true
        } else {
          this.searchResult = false
          if (this.jumpIndex > nodeList.length - 1) {
            this.jumpIndex = 0
          }
          nodeList[this.jumpIndex] && nodeList[this.jumpIndex].scrollIntoView({ behavior: 'smooth' })
          this.jumpIndex++
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.law_detail
  height 100vh
  .law-wrap
    height 100%
    display flex
    justify-content space-between
    padding 0.3rem 0.6rem 0.5rem 0.6rem
  .law-left
    display flex
    flex-direction column
    width 5.6rem
    height 100%
    z-index 1000
    margin-right 0.2rem
    .search-box
      margin-bottom 0.3rem
      .input-box
        display flex
        height 0.8rem
        background-color rgba(255, 255, 255, 0.2)
        border-radius 0.08rem
        input
          background none
          flex 1
          border 0
          padding 0 0.2rem
          color #fff
          font-size 0.28rem
          border-radius 0.1rem 0 0 0.1rem
        button
          width 1.4rem
          border 0
          height 0.8rem
          background-color #2f5ccd
          border-radius 0px 0.08rem 0.08rem 0px
          img
            width 0.49rem
            height 0.48rem
            object-fit cover
      .no-keywords
        font-size 0.3rem
        color #fff
      .no-search
        color #fff
        padding 0.15rem
    .menu-box
      flex 1
      color #fff
      padding 0 0.28rem
      background-color rgba(255, 255, 255, 0.2)
      border-radius 0.08rem
      overflow-y scroll
      border solid 1px rgba(255, 255, 255, 0.2)
    .hts
      display flex
      justify-content space-between
      padding 0.15rem 0
      margin 0.15rem 0
      font-size 0.28rem
      line-height 1
      text-align center
    .menulist
      list-style none
      flex 1
      margin 0 0.15rem
      overflow-y scroll
      .empty-info
        font-size 0.2rem
        padding 0 0.15rem
  .law-right
    position relative
    flex 1
    z-index 1
    height 100%
    background-color #fff
    border-radius 0.08rem
    overflow-y scroll
    .main-content
      flex-shrink 0
      box-sizing border-box
      margin 0
      padding 0.3rem 0.2rem 0 0.2rem
      .intro
        font-size 0.2rem
        color #999
        display flex
        flex-wrap wrap
        padding 0.2rem 0
        border-bottom 1px solid #eee
        span
          display block
          padding-right 0.2rem
          box-sizing border-box
          width 33.3%
          min-height 0.4rem
          line-height 1.4
      .chapter
        padding 0.3rem 0 0.25rem 0
        font-size 0.28rem
        font-weight 700
      .title
        font-size 0.24rem
        padding 0.43rem 0
        line-height 1.6
        border-bottom 1px solid #e5e5e5
      .item
        box-sizing border-box
        font-size 0.2rem
        margin-bottom 0.2rem
        color #333
      p
        margin 0
        line-height 1.8
        font-size 0.2rem
    .out-line
      flex auto
.outline-tree-list
  padding 0 0.15rem
  margin 0 0.15rem
.node-render-content
  cursor default
  font-size 0.24rem
  line-height 1.5
  color #fff
  overflow hidden
  text-overflow ellipsis
  white-space nowrap
.node-render-content:hover
  color #409EFF
.details-content
  padding 0.12rem 0.2rem
  text-align left
  h3
    display inline
  h3[level='1']
    color #333
    font-size 0.28rem
    text-align left
  h3[level='2']
    color #333
    font-size 0.24rem
  h3[level='3']
    color #333
    font-size 0.2rem
  p
    font-size 0.24rem
    padding-left 0.24rem
    display inline
  h1, h2, h3, h4, h5, h6
    line-height 1.6
  .pro-node
    line-height 1.6
    margin 0.2rem 0
    &:first-child
      margin-top 0
</style>
